import { useQuery } from 'react-query';
import { getForumTopics } from '../../../../service/forumTopic';

import Filter, { FilterItem } from '../../../../components/Filter/CustomFilter';
import useSearchParam from '../../../../hooks/useQueryParams';
import TopicItem from '../TopicItem/TopicItem';

interface PropsTopicList {
  forumId: number;
  clubId: number;
  userId: number;
  isAdminOrMediator: boolean;
}

export const TopicsList = ({ forumId, clubId, isAdminOrMediator, userId}: PropsTopicList) => {
  const [searchState, setSearchState] = useSearchParam<string, '0' | '1' | ''>('wasApproved');
  
  const {data: forumTopics, refetch} = useQuery(
    ['club', 'forumTopics', forumId, searchState],
    () => getForumTopics(forumId, clubId, searchState ? searchState : ''),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return(
    <div>
      {isAdminOrMediator && 
        <Filter>
          <FilterItem 
            onClick={e => setSearchState('')}
            active={!searchState}>
              Todos
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('1')} 
            active={searchState === '1'}>
              Aprovados
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('0')} 
            active={searchState === '0'}>
              Não aprovados
          </FilterItem>
        </Filter>
      }
      <div>
        {forumTopics?.map(topic => (
            topic.wasApproved === 1 || isAdminOrMediator || userId === topic.creatorUserId
          ) &&
          <TopicItem 
            forumTopic={topic} forumId={forumId} refetchData={refetch}
            clubId={clubId} isAdminOrMediator={isAdminOrMediator} isCreatorUser={userId === topic.creatorUserId}
          />
        )}
      </div>
      
    </div>
  );
}


